module.exports = __webpack_public_path__ + "img/icon_order_finish.30491e6e.png";